const removeDuplicates = (arr) => {
  const tagsToLowercase = [...new Set(arr.map((item) => item && item.trim().toLowerCase()).filter((item) => !!item))];
  const tags = arr.filter((item, i) => {
    return tagsToLowercase.indexOf(item.toLowerCase()) === i;
  });
  return tags;
};

const getTagsAsArray = (tags) =>
  tags
    .split(/[,]+/)
    .map((item) => item.trim())
    .filter((item) => !!item) || [];

export { getTagsAsArray, removeDuplicates };
